import './policy-body.component.scss'

const calcHeight = el => {
  let res = 0
  const el__childrens = el.children
  for (let count = 0; count < el__childrens.length; count++) {
    res += el__childrens[count].offsetHeight
  }
  return res
}
const technicalItems = document.querySelectorAll('.policy-list__item')

technicalItems.forEach(item => {
  const item__head = item.querySelector('.policy-list__head')
  const item__body = item.querySelector('.policy-list__body')

  item__head.addEventListener('click', () => {
    if (!item__head.classList.contains('opened') && !item__body.classList.contains('opened')) {
      item__head.classList.add('opened')
      item__body.classList.add('opened')
      item__body.style.height = `${calcHeight(item__body)}px`
    } else {
      item__body.style.height = `${calcHeight(item__body)}px`
      setTimeout(() => {
        item__head.classList.remove('opened')
        item__body.classList.remove('opened')
        item__body.removeAttribute('style')
      }, 1)
    }
  })
  item__body.addEventListener('transitionend', () => {
    if (item__body.classList.contains('opened')) {
      item__body.style.height = 'auto'
    } else {
      
    }
  })
})